import React, { Component, Fragment } from "react";
import MetisMenu from "react-metismenu";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as UsersService from "../../services/users/api_user";
import {
  ClientsNav
} from "./NavItems";

class Nav extends Component {
  state = {};

  render() {

    const grantAccess = UsersService.getAccessControl();

    return (
      <Fragment>
        {
          grantAccess === 1 || 2 ? (
            <Fragment>
              <h5 className="app-sidebar__heading">Clients</h5>
              <MetisMenu
                content={ClientsNav}
                activeLinkFromLocation
                className="vertical-nav-menu"
                iconNamePrefix=""
                classNameStateIcon="pe-7s-angle-down"
              />
            </Fragment>
          ) : (
            null
          )
        }
      </Fragment>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
}
const mapStateToProps = (state) => ({
  sidebarXFP: state.Header.sidebarXFP,
});

export default withRouter(connect(mapStateToProps)(Nav));



// WEBPACK FOOTER //
// ./src/Layout/AppNav/VerticalNavWrapper.js